export enum COLORS_MAPPING {
  BLUE = "#0169b4",
  GREEN = "#59a627",
  ORANGE = "#e94e10",
  MAINCOLOR = "#0f3250",
}

export function stringToHexColor(color: string): string {
  switch (color) {
    case "blue":
    case "mobility":
      return COLORS_MAPPING.BLUE;
    case "green":
    case "protection":
    case "saving":
      return COLORS_MAPPING.GREEN;
    case "orange":
    case "home":
    case "work":
      return COLORS_MAPPING.ORANGE;
    case "main-color":
      return COLORS_MAPPING.MAINCOLOR;
    default:
      return COLORS_MAPPING.BLUE;
  }
}
